import * as dayjs from 'dayjs'

import relativeTime from 'dayjs/plugin/relativeTime'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

const acceptLangs = ['tr', 'en']

import 'dayjs/locale/tr';
import 'dayjs/locale/en';

dayjs.extend(relativeTime)
dayjs.extend(utc)
dayjs.extend(timezone)

const getLocalData = () => {
  // const localData = JSON.parse(localStorage.getItem('store-preferences'))
  // const langCode = localData ? localData.profileData.language.code : 'tr'
  // const preferencesTimezone = localData ? localData.profileData.timezone : 'Europe/Istanbul'
  const langCode = 'tr'
  const preferencesTimezone = 'Europe/Istanbul'

  return {
    langCode,
    preferencesTimezone
  }
}

try {
  const { langCode, preferencesTimezone } = getLocalData()
  dayjs.tz.setDefault(preferencesTimezone)
  if (acceptLangs.includes(langCode)) {
    dayjs.locale(langCode)
  }
} catch {
  console.info('lang code not found')
}

const useDayjs = () => dayjs

export { useDayjs, getLocalData }

export default {
  dayjs
}
